import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewChild,
  Inject,
  forwardRef
} from '@angular/core';

import { 
  FormGroup,
  Validators 
} from '@angular/forms';

import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { isEqual, isNil, isEmpty } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  SeparatorModel,
  ButtonStyles 
} from './models/control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { ToolModel } from './models/tool';
import { TabItemModel, TabGroupModel } from './models/tab';
import { WidgetModel } from './models/widget';
import { FieldsetModel } from './models/fieldset';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_inventory_transformations_hub_ComponentContextService } from './FootprintManager.inventory_transformations_hub.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

import { FootprintManager_inventory_transformations_gridComponent } from './FootprintManager.inventory_transformations_grid.component';
import { InventoryTransformations_active_inventory_transformations_widgetComponent } from './InventoryTransformations.active_inventory_transformations_widget.component';
import { InventoryTransformations_inventory_transformations_by_status_widgetComponent } from './InventoryTransformations.inventory_transformations_by_status_widget.component';
import { Owners_owners_dd_singleComponent } from './Owners.owners_dd_single.component'
import { Owners_projects_dd_singleComponent } from './Owners.projects_dd_single.component'
import { Locations_warehouses_dd_singleComponent } from './Locations.warehouses_dd_single.component'
import { InventoryTransformations_inventory_transformation_statuses_dd_multiComponent } from './InventoryTransformations.inventory_transformation_statuses_dd_multi.component'

@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => FootprintManager_inventory_transformations_gridComponent),
    forwardRef(() => InventoryTransformations_active_inventory_transformations_widgetComponent),
    forwardRef(() => InventoryTransformations_inventory_transformations_by_status_widgetComponent),
    forwardRef(() => Owners_owners_dd_singleComponent),
    forwardRef(() => Owners_projects_dd_singleComponent),
    forwardRef(() => Locations_warehouses_dd_singleComponent),
    forwardRef(() => InventoryTransformations_inventory_transformation_statuses_dd_multiComponent),
  ],
  selector: 'FootprintManager-inventory_transformations_hub',
  templateUrl: './FootprintManager.inventory_transformations_hub.component.html'
})
export class FootprintManager_inventory_transformations_hubComponent extends BaseComponent implements OnInit, OnDestroy {


  @Input() showInDialog: boolean = false; 
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();  
  //#endregion Outputs
  hasToolbar: boolean = true;



  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  //#endregion
  formGroup: FormGroup = new FormGroup({
    owner: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    project: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    warehouse: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    status: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });
  
  toolbar = {
      new_dropdown: new ToolModel(new SplitButtonModel<{ quick_transformation: ButtonModel, advanced: ButtonModel }>(
        'new_dropdown',
        new ButtonStyles(['creation'], null),
        false,
        false,
        'New',
        'icon-ic_fluent_add_20_regular',
        null,
        [
          new ButtonModel('quick_transformation', new ButtonStyles(null, null), false, false, false, 'Quick transformation', ''),
          new ButtonModel('advanced', new ButtonStyles(null, null), false, false, false, 'Advanced transformation', '')
        ])
    , false)
  };

  actionbar = {
  };

 filters = {
    owner: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['owner'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Owner', false, false),
    project: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['project'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Project', false, false),
    warehouse: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['warehouse'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Warehouse', false, false),
    status: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['status'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Status', false, false),
  };


  filtersets = {
    newGroup1: new FieldsetModel(
      'Filters',
      false,
      true,
      true,
      false,
        null
      ,
      () => {
        const $hub = this;
        const $utils = this.$utils;
        return '';
      }
    ),
};

    rootTabGroup = new TabGroupModel();
  
    subTabGroups = {
    };
  
    onTabSelected(event: MatSelectChange) {
      event.value.activate();
    }
  
    tabs = {
      transformation_orders: new TabItemModel(
        this.rootTabGroup, 
        'Transformation orders', 
        false,
        ),
    };
  
  
    //#region tabs inParams
    get $tabs_transformation_orders_inventory_transformations_grid_inParams_owner_id(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.owner.control.value;
      
      return expr;
    }
  
    get $tabs_transformation_orders_inventory_transformations_grid_inParams_project_id(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.project.control.value;
      
      return expr;
    }
  
    cacheValueFor_$tabs_transformation_orders_inventory_transformations_grid_inParams_warehouse_ids: number[];
    get $tabs_transformation_orders_inventory_transformations_grid_inParams_warehouse_ids(): number[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $utils.isDefined($hub.filters.warehouse.control.value) ? [$hub.filters.warehouse.control.value] : null;
      
      if(!isEqual(this.cacheValueFor_$tabs_transformation_orders_inventory_transformations_grid_inParams_warehouse_ids, expr)) {
        this.cacheValueFor_$tabs_transformation_orders_inventory_transformations_grid_inParams_warehouse_ids = expr;
      }
      return this.cacheValueFor_$tabs_transformation_orders_inventory_transformations_grid_inParams_warehouse_ids;
    }
  
    cacheValueFor_$tabs_transformation_orders_inventory_transformations_grid_inParams_status_ids: number[];
    get $tabs_transformation_orders_inventory_transformations_grid_inParams_status_ids(): number[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.status.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_transformation_orders_inventory_transformations_grid_inParams_status_ids, expr)) {
        this.cacheValueFor_$tabs_transformation_orders_inventory_transformations_grid_inParams_status_ids = expr;
      }
      return this.cacheValueFor_$tabs_transformation_orders_inventory_transformations_grid_inParams_status_ids;
    }
  
    //#endregion tabs inParams
  
    //#region tabs children
      @ViewChild('$tabs_transformation_orders', { read: FootprintManager_inventory_transformations_gridComponent }) $tabs_transformation_orders: FootprintManager_inventory_transformations_gridComponent;
    //#endregion tabs children
    widgets = {
      active_transformations_widget: new WidgetModel(false),
      inventory_transformations_by_status_widget: new WidgetModel(false),
    };
  
    //#region widgets inParams
    get $widgets_active_transformations_widget_inParams_owner_id(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.owner.control.value;
      
      return expr;
    }
  
    get $widgets_active_transformations_widget_inParams_project_id(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.project.control.value;
      
      return expr;
    }
  
    cacheValueFor_$widgets_active_transformations_widget_inParams_warehouse_ids: number[];
    get $widgets_active_transformations_widget_inParams_warehouse_ids(): number[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $utils.isDefined($hub.filters.warehouse.control.value) ? [$hub.filters.warehouse.control.value] : null;
      
      if(!isEqual(this.cacheValueFor_$widgets_active_transformations_widget_inParams_warehouse_ids, expr)) {
        this.cacheValueFor_$widgets_active_transformations_widget_inParams_warehouse_ids = expr;
      }
      return this.cacheValueFor_$widgets_active_transformations_widget_inParams_warehouse_ids;
    }
  
    get $widgets_inventory_transformations_by_status_widget_inParams_owner_id(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.owner.control.value;
      
      return expr;
    }
  
    get $widgets_inventory_transformations_by_status_widget_inParams_project_id(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.project.control.value;
      
      return expr;
    }
  
    cacheValueFor_$widgets_inventory_transformations_by_status_widget_inParams_warehouse_ids: number[];
    get $widgets_inventory_transformations_by_status_widget_inParams_warehouse_ids(): number[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $utils.isDefined($hub.filters.warehouse.control.value) ? [$hub.filters.warehouse.control.value] : null;
      
      if(!isEqual(this.cacheValueFor_$widgets_inventory_transformations_by_status_widget_inParams_warehouse_ids, expr)) {
        this.cacheValueFor_$widgets_inventory_transformations_by_status_widget_inParams_warehouse_ids = expr;
      }
      return this.cacheValueFor_$widgets_inventory_transformations_by_status_widget_inParams_warehouse_ids;
    }
  
    cacheValueFor_$widgets_inventory_transformations_by_status_widget_inParams_status_ids: number[];
    get $widgets_inventory_transformations_by_status_widget_inParams_status_ids(): number[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.status.control.value;
      
      if(!isEqual(this.cacheValueFor_$widgets_inventory_transformations_by_status_widget_inParams_status_ids, expr)) {
        this.cacheValueFor_$widgets_inventory_transformations_by_status_widget_inParams_status_ids = expr;
      }
      return this.cacheValueFor_$widgets_inventory_transformations_by_status_widget_inParams_status_ids;
    }
  
    //#endregion widgets inParams
  
    //#region widgets children
      @ViewChild('$widgets_active_transformations_widget', { read:  InventoryTransformations_active_inventory_transformations_widgetComponent }) $widgets_active_transformations_widget: InventoryTransformations_active_inventory_transformations_widgetComponent;
      @ViewChild('$widgets_inventory_transformations_by_status_widget', { read:  InventoryTransformations_inventory_transformations_by_status_widgetComponent }) $widgets_inventory_transformations_by_status_widget: InventoryTransformations_inventory_transformations_by_status_widgetComponent;
    //#endregion widgets children

  //#region filters inParams
  get $fields_owner_selector_inParams_statusId(): number {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = 1;
    
    return expr;
  }



  get $fields_owner_selector_inParams_projectId(): number {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = $hub.filters.project.control.value;
    
    return expr;
  }



  get $fields_project_selector_inParams_statusId(): number {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = 1;
    
    return expr;
  }



  get $fields_project_selector_inParams_ownerId(): number {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = $hub.filters.owner.control.value;
    
    return expr;
  }



  //#endregion filters inParams

  get hubTitle(): string {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Inventory transformations hub`;
  }

  get hubDescription(): string {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Your landing page for performaing and viewing Inventory transformations.`;
  }

  constructor(
  private $utils: UtilsService,
  private $settings: SettingsValuesService,
  private $shell: FootprintManager_ShellService,
  private $datasources: FootprintManager_DatasourceService,
  private $flows: FootprintManager_FlowService,
  private $reports: FootprintManager_ReportService,
  private $localization: FootprintManager_LocalizationService,
  private $operations: FootprintManager_OperationService,
  private $logger: CleanupLoggerService,
  private $context: FootprintManager_inventory_transformations_hub_ComponentContextService,
  ) { 
    super();
    this.$subscribeFormControlValueChanges();
    this.hasToolbar = !isEmpty(this.toolbar);

    //#region tabs tab init
    this.rootTabGroup.tabs = [
      this.tabs.transformation_orders,
    ]; 
    //#endregion tabs tab init
  }

  ngOnInit(): void {
    this.$init();
  }
  

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }



  initialized = false;

  async $init() {
    this.title = 'Inventory transformations hub';
    
    const $hub = this;
    const $utils = this.$utils;

    (this.filters.status.control as SelectBoxModel).reset([1,2]);


    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
  }
  close() {
    this.$finish.emit();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = Promise.resolve(null);
    
    // children
    if (skipChildren === false) {
      this.$refreshChildren(childToSkip);
    }

    return result;
  }

  $refreshChildren(childToSkip: string) {
    //#region widgets children
    if (childToSkip !== '$widgets_active_transformations_widget') {
      if (!isNil(this.$widgets_active_transformations_widget) && !this.widgets.active_transformations_widget.hidden) {
        this.$widgets_active_transformations_widget.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$widgets_inventory_transformations_by_status_widget') {
      if (!isNil(this.$widgets_inventory_transformations_by_status_widget) && !this.widgets.inventory_transformations_by_status_widget.hidden) {
        this.$widgets_inventory_transformations_by_status_widget.refresh(true, false, null);
      }
    }
    //#endregion widgets children
    //#region tabs children
    if (childToSkip !== '$tabs_transformation_orders') {
      if (!isNil(this.$tabs_transformation_orders) && !this.tabs.transformation_orders.hidden) {
        this.$tabs_transformation_orders.refresh(true, false, null);
      }
    }
    //#endregion tabs children
  }

  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_quick_transformation_clicked(event = null) {
    return this.on_quick_transformation_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_quick_transformation_clickedInternal(
    $hub: FootprintManager_inventory_transformations_hubComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_transformations_hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'inventory_transformations_hub.on_quick_transformation_clicked');
  
  
  
  
  
  //Spawns the Quick transformation wizard
  let inventory_transformation = (await $shell.FootprintManager.openinventory_transformation_quick_wizardDialog({
      is_quick_transformation: true,
      owner_id: $hub.filters.owner.control.value,
      project_id: $hub.filters.project.control.value,
      warehouse_id: $hub.filters.warehouse.control.value}))
      
  //this will refresh the grid when the wizard closes
  if ($utils.isDefined(inventory_transformation?.inventory_transformation_id))
  {
      await $shell.FootprintManager.openinventory_transformation_editor({inventory_transformation_id: inventory_transformation?.inventory_transformation_id})
  }
  await $hub.refresh()
  }
  on_advanced_transformation_clicked(event = null) {
    return this.on_advanced_transformation_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_advanced_transformation_clickedInternal(
    $hub: FootprintManager_inventory_transformations_hubComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_transformations_hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'inventory_transformations_hub.on_advanced_transformation_clicked');
  
  
  
  
  
  //Spawns the Advanced transformation wizard
  let inventory_transformation =  (await $shell.FootprintManager.openinventory_transformation_creation_form({
      quick_transform: false,
      ownerId: $hub.filters.owner.control.value,
      projectId: $hub.filters.project.control.value,
      warehouseId: $hub.filters.warehouse.control.value,
  }))
  
  /*
  if ($utils.isDefined(inventory_transformation?.inventory_transformation.id))
  {
      await $shell.FootprintManager.openinventory_transformation_editor({inventory_transformation_id: inventory_transformation?.inventory_transformation.id})
  }
  await $hub.refresh()
  */
  }
  //#endregion private flows
}
